import React, { FC, ReactNode } from 'react'
import Button from './../Button/Button';
import c from './style.module.css'

interface IModalLayout {
    closeModal?: () => void
    hideClose?: boolean
    children: ReactNode
    title?: string | ReactNode
    description?: string | ReactNode
    bottomDescription?: string | ReactNode
    actions?: {
        title: string
        action: (complete: () => void) => void
        type?: 'primary' | 'second'
        loading?: boolean
    }[]
}

const ModalLayout: FC<IModalLayout> = ({
    children, closeModal, title, hideClose,
    actions, description, bottomDescription
}) => {
    return (
        <div
            className={c.modalDonat}
            onClick={closeModal}
        >
            <div
                className={c.modalDonatContainer}
                onClick={(e) => e.stopPropagation()}
            >
                {closeModal && !hideClose && (
                    <button
                        onClick={closeModal}
                        className={c.modalDonatClose}
                    />
                )}

                <div className={c.modalDonatContent}>
                    {
                        title &&
                        <div className={c.modalTitle}>
                            {title}
                        </div>
                    }

                    <div className={c.modalDescription}>
                        {description}
                    </div>

                    {children}

                    {
                        actions &&
                        <div className={c.modalActionsContainer}>
                            {actions.map((action) => {
                                let actionType = c.modalAction;

                                switch (action.type) {
                                    case 'second':
                                        actionType += ' ' + c.modalActionSecond;
                                        break;
                                }

                                return (
                                    <div
                                        key={action.title + action.type}
                                        className={c.modalAction}
                                    >
                                        <Button
                                            title={action.title}
                                            type={action.type}
                                            action={action.action}
                                            loading={action.loading}
                                        ></Button>
                                    </div>
                                )
                            })}
                        </div>
                    }

                    {bottomDescription && (
                        <div className={c.modalBottomDescription}>
                            {bottomDescription}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ModalLayout;